export type DrawableGeometryType = 'Point' | 'LineString' | 'Polygon'

/**
 * Нормализует geom_type каталога к типу, с которым работают карта и Create V2.
 * Circle, None и пустые значения трактуются как Point (один клик на карте).
 */
export const normalizeDrawableGeometryType = (
  figureType: string | null | undefined,
): DrawableGeometryType => {
  if (figureType === 'LineString' || figureType === 'Polygon' || figureType === 'Point') {
    return figureType
  }
  return 'Point'
}

/**
 * Функция определения типа объекта линия
 */
export const isLine = (figureType: string | null | undefined) => figureType === 'LineString'

/**
 * Функция определения типа объекта полигон
 */
export const isPolygon = (figureType: string | null | undefined) => figureType === 'Polygon'

/**
 * Точечное размещение на карте: Point, Circle, None/null и прочие не line/polygon.
 */
export const isPoint = (figureType: string | null | undefined) =>
  !isLine(figureType) && !isPolygon(figureType)

/** Безопасно читает geom_type когда catalog figure отсутствует (null). */
export function resolveFigureGeomType(
  figure: { geom_type?: string | null } | null | undefined,
): string | null | undefined {
  return figure?.geom_type ?? null
}
